var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockInIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-44.4%",
    y: "-44.4%",
    width: "188.9%",
    height: "188.9%",
    filterUnits: "objectBoundingBox",
    id: "4yaqsasb6a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 4,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.662745098 0 0 0 0 0.811764706 0 0 0 0 0.239215686 0 0 0 0.3 0",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#4yaqsasb6a)",
    transform: "translate(4)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 18,
    cy: 18,
    r: 12.375
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 0C8.064 0 0 8.064 0 18s8.064 18 18 18 18-8.064 18-18S27.936 0 18 0zm-3.6 24.3V11.7c0-.738.846-1.17 1.44-.72l8.406 6.3a.893.893 0 0 1 0 1.44l-8.406 6.3c-.594.45-1.44.018-1.44-.72z",
    fill: "#A9CF3D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockInIcon);
export default __webpack_public_path__ + "static/media/clock-in-icon.af194528856d8add9835e8f692d2c58d.svg";
export { ForwardRef as ReactComponent };